import mailcheck from "mailcheck";

import { FIELDS } from "../util/constants";
import OkC from "shared/util/OkcApi";
import _str from "shared/util/_str";

export const validateEmail = (value, pass, fail, seenSuggestion) => {
	if (!value) {
		return fail(_str("Email is required"));
	}

	// simple regex for a@b.c
	if (!/^[^ ]+@[^ ]+\.[^ ]+$/.test(value)) {
		return fail(_str("Invalid email address"));
	}

	// check if they have a misspelling
	let suggestion;

	if (!seenSuggestion) {
		mailcheck.run({
			email: value,
			suggested: (suggested) => {
				suggestion = suggested.full;
			},
		});
	}

	if (suggestion) {
		// mark email suggestion as a pass
		return pass(_str(`Did you mean ${suggestion}?`), suggestion);
	}

	// Then check with the server.
	OkC.post("/signup/check_email", {
		api: 1,
		data: {
			email: value,
		},
	}).then((res) => {
		if (res.is_valid) {
			return pass();
		} else {
			return fail(_str(res.message));
		}
	}).catch(() => {
		return fail(_str("Unable to confirm your email"));
	});

	return null;
};

export const validatePassword = (value, pass, fail) => {
	// Make sure it's not blank, or too short.
	if (!value) {
		return fail(_str("Password is required"));
	}

	if (value.length < 6) {
		return fail(_str("That password is too short"));
	}

	OkC.post("/okc/check_password", {
		data: { password: value },
	})
		.then((res) => {
			if (!res) {
				throw new Error();
			}
			else if (!res.is_valid) {
				return fail(_str("That password isn't secure"));
			}
			else {
				return pass(_str("Strong password"));
			}
		})
		.catch(() => {
			return fail(_str("There was an error"));
		});

	return null;
};

export function validate(params) {
	const {
		field, value, seenSuggestion, pass, fail,
	} = params;

	switch (field) {
		case FIELDS.EMAIL: {
			return validateEmail(value, pass, fail, seenSuggestion);
		}

		case FIELDS.PASSWORD: {
			return validatePassword(value, pass, fail);
		}

		default:
			return true;
	}
}

export function createErrorMessage(reasons) {
	let message = _str("Something went wrong. Please try again.");

	if (reasons && reasons.length === 1) {
		const [reason] = reasons;

		if (reason === "CAF_EMAIL_INVALID") {
			message = _str("That email is invalid; try something different!");
		}
	}

	return message;
}



// WEBPACK FOOTER //
// ./src/apps/signup/util/helper.js